import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

const style = require('./index.css');

export interface IMortgageProps {
  context: IAdFoxBannerContext;
}

export const CommercialMortgageBanner: React.FC<IMortgageProps> = ({ context }) => {
  return (
    <span className={style['container']}>
      <a href={context.link} target="_blank" className={style['link']} rel="nofollow noopener noreferrer">
        {context.name}
      </a>
      <span className={style['dot']}>&nbsp;·&nbsp;</span>
      <a href={context.link} target="_blank" className={style['title']} rel="nofollow noopener noreferrer">
        Бизнес-ипотека
      </a>
    </span>
  );
};
